<template>
  <el-tooltip v-if="helpText && helpText.trim() !== ''" :content="helpText" placement="top">
    <div :style="{ cursor: 'pointer', backgroundColor: 'transparent!important', color: color + '!important'}" class="icon icon-sm icon-shape bg-white shadow rounded-circle">
      <i class="fas fa-question-circle"></i>
    </div>
  </el-tooltip>
</template>

  <script>
  export default {
    name: 'HelpIcon',
    props: {
      helpText: {
        type: String,
        required: true
      },
      color: {
        type: String,
        default: '#525f7f'
      }
    }
  }
  </script>